// useBulkUsage({ enabled? }) → UseQueryResult<BulkUsage>     key ["bulk-usage"]
// Signed-in viewer's rolling-24h bulk-submit count (GET /v1/bulk/usage). Enable only
// when a session exists — the endpoint 401s otherwise. Invalidated by a successful
// bulk submit so the badge updates without a page refresh.
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { BulkUsage } from "@/types";
import { keys } from "./keys";

export function useBulkUsage(opts: { enabled?: boolean } = {}) {
  return useQuery<BulkUsage>({
    queryKey: keys.bulkUsage,
    queryFn: () => api.bulkUsage(),
    staleTime: 60_000,
    enabled: opts.enabled ?? true,
    retry: 1,
  });
}
